module.exports = __webpack_public_path__ + "static/media/SDFSA_3-682w.cdf5a4d1.webp";